import React from 'react';
import * as XLSX from 'xlsx';

const ExcelExportButton = ({ data = [], fileName, label, lable }) => {
  const exportLabel = label || lable;

  const newData = data.map((item) => {
    const newItem = { ...item };
    Object.keys(item).forEach((key) => {
      if (Array.isArray(item[key])) {
        newItem[key] = item[key].join(", ");
      }
    });
    return newItem;
  });

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(newData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  return (
    <button className="btn btn-outline-secondary" onClick={exportToExcel} type="button">
      <i className="material-icons" aria-hidden="true">download</i>
      {exportLabel || 'Export to Excel'}
    </button>
  );
};

export default ExcelExportButton;
